var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7662 4.39809C14.7673 3.11914 12.1594 2.08325 8.94616 2.08325C5.73288 2.08325 3.12733 3.1203 3.125 4.39809M3.125 4.39809C3.125 5.67704 5.73055 6.71293 8.94616 6.71293C12.1618 6.71293 14.7673 5.67704 14.7673 4.39809L14.7673 13.3796M3.125 4.39809V18.287C3.12616 19.566 5.73172 20.6019 8.94616 20.6019C10.5051 20.6019 11.9126 20.3554 12.9569 19.9584M3.12616 9.02775C3.12616 10.3067 5.73172 11.3426 8.94733 11.3426C12.1629 11.3426 14.7685 10.3067 14.7685 9.02775M13.0268 15.3068C11.9767 15.7177 10.5365 15.9723 8.94616 15.9723C5.73172 15.9723 3.12616 14.9364 3.12616 13.6575M21.3825 14.0256C23.4281 16.0592 23.4281 19.3578 21.3825 21.3914C19.3369 23.425 16.0189 23.425 13.9733 21.3914C11.9278 19.3578 11.9278 16.0592 13.9733 14.0256C16.0189 11.992 19.3369 11.992 21.3825 14.0256Z",
    stroke: "#1479FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.52d225c9ed0d42a0e2659388469debc3.svg";
export { ForwardRef as ReactComponent };